import { Route } from 'react-router-dom';

import { Contacts } from './contacts/contacts.component';

export function ApplicationAddressBookRoutes() {
    return (
        <Route path='address_book'>
            <Route
                path='contacts'
                element={<Contacts />}
            />
        </Route>
    );
}
